const SearchClearIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99786 17.4844C6.05543 17.4844 2.85938 14.2883 2.85938 10.3459C2.85938 6.40349 6.05543 3.20741 9.99786 3.20741C13.9403 3.20741 17.1363 6.40347 17.1363 10.3459C17.1363 14.2883 13.9403 17.4844 9.99786 17.4844ZM13.4477 7.75891L12.5846 6.89611L9.99786 9.48312L7.41109 6.89611L6.54805 7.75891L9.13482 10.3459L6.54805 12.9327L7.41039 13.7957L9.99762 11.2087L12.5846 13.7957L13.4477 12.9327L10.8607 10.3457L13.4477 7.75891Z"
        fill="#222232"
        fillOpacity="0.3"
      />
    </svg>
  )
}

export default SearchClearIcon
